import type { App } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
export { default as useUserStore } from './modules/user';
export { default as useShareStore } from './modules/share';
export { default as usePositioningStore } from './modules/local';
export { default as useDeviceStore } from './modules/device';
export { default as useShappingStore } from './modules/shapping';
export { default as useAiStore } from './modules/ai';
export { default as useDayTestStore } from './modules/dayTest';
export { default as useQuizStore } from './modules/quiz';
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

export function setupStore(app: App<Element>) {
  app.use(pinia);
}

export default pinia;
